import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { getAnimationDelay } from "./animations";

interface SpaceSummaryHeaderProps {
  formattedDateRange: string;
  sourceName: string;
}

export const SummaryHeader = ({
  formattedDateRange,
  sourceName,
}: SpaceSummaryHeaderProps) => (
  <div
    className="text-tertiary animate-fade-in-slow mb-2 text-sm opacity-0"
    style={{
      animationDelay: getAnimationDelay(0),
      animationFillMode: "forwards",
    }}
  >
    {formattedDateRange} {t("ai_spaces_summaries.bullet")}{" "}
    {t("ai_spaces_summaries.summary_of")}
    <div
      className="animate-fade-in-slow opacity-0"
      style={{
        animationDelay: getAnimationDelay(1),
        animationFillMode: "forwards",
      }}
    >
      <Typography.TitleMd>{sourceName}</Typography.TitleMd>
    </div>
  </div>
);
